import axiosInstanceBuilder from "../axiosInstance"
const axiosInstance = axiosInstanceBuilder('api')

export const closeTicket = (id:string) => {
  return axiosInstance.put(`/tickets/${id}/close`, {})
}

export const updateTicket = (id:string, data: {category: number, subject: number}) => {
  return axiosInstance.put(`/tickets/${id}`, data)
}

export const transferTicket = (id:string, data: {departmentId: number, message: string, isHide: boolean}) => {
  return axiosInstance.put(`/tickets/${id}/transfer`, data)
}

export const makeSeenTicket = (id:string) => {
  return axiosInstance.put(`/tickets/${id}/make-seen`, {})
}

export const uploadTicketFile = (data: any, id: number, ticketId: string) => {
  return axiosInstance.put(`/tickets/${ticketId}/content/${id}/file`,data)
}